import { GAMESTATE } from '@config/constants.js';

const WAITING_TIME = 0;

export const getTimeoutGameState = (round) => {
  if(round === undefined) return { timeout: 0, gameState: GAMESTATE.WAITING_NEW_GAME };

  const {timeBet, timeWaitingNewGame} = round.table;
  const status = round.status;
  // const d = new Date();
  const d = new Date(round.currentDate);
  const createdDate = new Date(round.createdDate);
  let timeout = timeBet - ((d - createdDate)/1000);
  timeout = Math.round(timeout) + WAITING_TIME;

  let gameState = "";
  switch(status){
    case GAMESTATE.BETTING:
      if(timeout > 5){
        gameState = GAMESTATE.BETTING;
      }
      else if(timeout >= 0 && timeout <= 5){
        gameState = GAMESTATE.LOCKING;
      }
      else {
        gameState = GAMESTATE.WAITING_NEW_GAME;
      }
      break;
    default:
      gameState = GAMESTATE.WAITING_NEW_GAME;
      break;
  }

  console.log(`++ round: ${round.id}:${round.status}:${timeBet} , timeout: ${timeout}, timeWaitingNewGame: ${timeWaitingNewGame}', gameState: ${gameState}'`);

  return {timeout, gameState};
};

export const processTick = (container) => {
  if(container.gameState === GAMESTATE.LOADING) return;

  container.timeout -= 1;
  if(container.timeout === 5){
    container.gameState = GAMESTATE.LOCKING;
    container.pushNewWaitingResult({ table: container.tableId });

    // hide bet dialog
    container.hideBetDialogByGame(container.table);
  }
  else if(container.gameState === GAMESTATE.LOCKING){
    if(container.timeout <= 0){
      container.gameState = GAMESTATE.WAITING_RESULT;
    }
  }
};
